import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { FaCircle } from "react-icons/fa";
import colors from "styles/colors.module.scss";
import "./RadioGroup.scss";

function RadioGroup(props) {
  const { className, options, value, onChange, readOnly, disabled } = props;
  const [selected, setSelected] = useState(null);
  const onOptionClick = (selectedValue) => {
    setSelected(selectedValue);
    onChange(selectedValue);
  };
  useEffect(() => {
    setSelected(value);
  }, [value]);
  const readOnlyCls = readOnly ? "read-only" : "";

  const disabledCls = disabled ? "disabled" : "";
  return (
    <div className={`radio-group ${className} ${readOnlyCls} ${disabledCls}`} data-testid="radio-group">
      {options.map((option) => {
        const checkedCls = option.value === selected ? "checked" : "";
        const disabledCls = option.disabled ? "disabled" : "";
        return (
          <div
            className={`radio-option ${checkedCls} ${disabledCls}`}
            onClick={onOptionClick.bind(null, option.value)}
            key={option.value}
          >
            <div className="radio-circle">
              {checkedCls && (
                <FaCircle
                  className="radio-checked-icon"
                  color={colors.lightBlue}
                />
              )}
            </div>
            <div className="radio-label">{option.label}</div>
          </div>
        );
      })}
    </div>
  );
}

RadioGroup.propTypes = {
  className: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
      disabled: PropTypes.bool,
    })
  ).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
};

RadioGroup.defaultProps = {
  className: "",
  value: null,
  onChange: () => {},
  readOnly: false,
};

export default RadioGroup;
